export enum IdentificationType {
  MyKad = 1,
  MyTentera = 2,
  Passport = 3,
}
